/**
 * Inspiration: https://docs.microsoft.com/en-us/dotnet/api/microsoft.toolkit.uwp.ui.extensions.dispatchertimerextensions.debounce?view=win-comm-toolkit-dotnet-6.1
 * Example: if you want to call a function in an infinite loop but only expect it to run once every let's say 20ms.
 * then this is the function to use.
 * Use Cases:
 *            1. Imagin a request being sent everytime user presses a button in th UI. Lets say our user is evil and
 *            will press the button really fast in that case.
 *            you may want to only send it once every so often so that user don't end up DOS ( Denial-of-Service )
 *            your api.
 *
 *            2. an auto-complete search is a perfect example of debounce. you may only want to send the request when
 *            right after a user is done typing a few words. not on every key stroke.
 *
 * @author Ishu Sharma
 * @param func
 * @param delay
 * @returns {(function(): void)|*}
 */

export default function (func, delay) {
    let timeout;
    return (...args) => {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
    };
}